import React from "react";
import { HOME } from "@/constants/testIds";
import { Cursor, FileText, Truck, CheckCircle } from "@phosphor-icons/react";

const STEPS = [
  {
    n: "01",
    title: "Pick Your Bin",
    desc: "Choose your size and waste type. Not sure? Call us — we'll match the right bin to your project in 30 seconds.",
    icon: Cursor,
  },
  {
    n: "02",
    title: "Book in Minutes",
    desc: "Submit our quick quote form or pick up the phone. We confirm same-day, 7 days a week.",
    icon: FileText,
  },
  {
    n: "03",
    title: "We Deliver",
    desc: "Same-day delivery on orders before noon. Driveway-safe drop with care for your property.",
    icon: Truck,
  },
  {
    n: "04",
    title: "We Haul Away",
    desc: "Fill at your pace — 7 days included. One call and the bin is gone. Honest weigh, no surprises.",
    icon: CheckCircle,
  },
];

export default function HowItWorks() {
  return (
    <section data-testid={HOME.stepsSection} id="how-it-works" className="bg-white border-b-2 border-slate-200">
      <div className="mx-auto max-w-7xl px-6 lg:px-8 py-20 lg:py-28">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 mb-14">
          <div>
            <div className="text-[11px] font-extrabold tracking-[0.22em] uppercase text-sky-600">How it works</div>
            <h2 className="font-display font-black text-3xl sm:text-4xl lg:text-5xl text-slate-900 mt-3 max-w-2xl leading-tight">
              From booked to hauled — without the runaround.
            </h2>
          </div>
          <p className="text-slate-600 max-w-md leading-relaxed">
            We answer the phone. We show up. We charge what we quoted. That&apos;s the whole pitch.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-0 border-2 border-slate-900 divide-y-2 sm:divide-y-0 sm:divide-x-2 lg:divide-x-2 divide-slate-900">
          {STEPS.map((s, i) => (
            <div
              key={s.n}
              className={`group relative bg-white p-7 sm:p-8 hover:bg-slate-50 transition-colors ${
                i % 2 === 1 ? "sm:border-l-0" : ""
              }`}
            >
              <div className="flex items-center justify-between">
                <span className="font-display font-black text-5xl text-slate-200 group-hover:text-sky-200 transition-colors">
                  {s.n}
                </span>
                <s.icon size={36} weight="bold" className="text-slate-900 group-hover:text-sky-500 transition-colors" />
              </div>
              <h3 className="font-display font-bold text-xl text-slate-900 mt-6">{s.title}</h3>
              <p className="mt-3 text-slate-600 leading-relaxed text-sm">{s.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
